import { render } from "./Z05Ranking.vue?vue&type=template&id=4bb82422&scoped=true&ts=true"
import script from "./Z05Ranking.vue?vue&type=script&lang=ts"
export * from "./Z05Ranking.vue?vue&type=script&lang=ts"

import "./Z05Ranking.vue?vue&type=style&index=0&id=4bb82422&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb82422"]])

export default __exports__